
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.86 2.742h-.805a1.166 1.166 0 00-.25-.562.616.616 0 00-.5-.227c-.558 0-.925.453-1.102 1.36-.099.53-.172 1.463-.219 2.796.698.11 1.302.388 1.813.836.667.589 1.075 1.282 1.226 2.078l.743-1.421.554.289-1.203 2.351-.437.11-2.164-1.336.304-.54 1.375.766c-.15-.599-.484-1.138-1-1.617a2.549 2.549 0 00-1.226-.656c-.016.75-.024 1.601-.024 2.554 0 2.688-.247 4.82-.742 6.399-.49 1.578-1.357 2.367-2.601 2.367-.25 0-.47-.02-.657-.062a2.172 2.172 0 01-.547-.204L.5 16.484h.734c.068.25.167.456.297.618.136.161.326.242.57.242.547 0 .891-.568 1.032-1.703.14-1.13.21-2.782.21-4.954 0-1.374.042-2.596.126-3.664h-.055a2.555 2.555 0 00-1.187.774c-.516.599-.816 1.323-.899 2.172L.36 9.82c.079-.979.472-1.849 1.18-2.61a3.484 3.484 0 011.977-1.07h.03c.131-1.16.319-2.111.563-2.85C4.625 1.741 5.516.968 6.781.968c.183 0 .383.026.602.078.224.047.414.107.57.18L7.86 2.742z","fill":"currentColor"}})])
          )
        }
      }
    